import {
    getCookie
} from "@/utils/util.js";
import AppConfig from "@/config/app.config.js";

import {
    mapGetters
} from "vuex";
import _ from 'lodash'
export default {
    install(Vue) {
        Vue.mixin({
            data() {
                return {
                    // cjImgBaseUrl: "http://106.54.87.159:50008/mallgoods-dev",
                    // imgBaseUrl: "https://h5.haomeiwei.top",
                    // //ossUploadUrl: "http://localhost:8081/mall-api/admin/minio/upload",
                    ossUploadUrl: "https://images.cdqidian.cn/image-upload/",
                    ossUploadRequestHeaders: {
                        authorization: "Bearer " + getCookie("token"),
                    },
                    ossUploadFileList: [],

                    imgBaseUrl: 'https://tall.cpic.fun',
                    lodash: _,

                }
            },
            computed: {
                ...mapGetters(["org"]),
                ossUploadRequsetData() {
                    return {
                        app_tag: AppConfig.app_tag,
                        organization: (this.org || {}).id,
                    };
                },
            },
            methods: {

                recharge_workers_set_password_sms() {
                    setPassword_get
                },
                rmObjNull(data) {
                    return Object.keys(data)
                        .filter((key) => data[key] !== null && data[key] !== undefined)
                        .reduce((acc, key) => ({
                            ...acc,
                            [key]: data[key]
                        }), {});
                },
                // //根据活动ID获取该活动下面的所有奖品
                // getMarkPrizeInfosOp(pgId){
                // 	return this.MarkPrizeInfosOp.filter((item,index)=>{
                // 		return item.pgId==pgId
                // 	})
                // },

                // goRefresh(path,data){
                // 	let vm = this;
                // 	 vm.$router.push({path:path,query:data})
                // 	 vm.$refreshPage(path)
                // },
                // go(path){
                // 	let vm = this;
                // 	vm.$router.push(path)
                // },
                // getTimeStr(time) {
                // 	return this.$moment(time).format('YYYY-MM-DD HH:mm:ss')
                // },
                // upperFirst(str) {
                // 	return str.substring(0, 1).toUpperCase() + str.substring(1)

                // },
                // getDict(key, val) {

                // 	let upperFirstKey = this.upperFirst(key + "-" + val);
                // 	// let upperFirstKey=key+"-"+val;

                // 	let objKeys = Object.keys(this.dictInfoAllMap);
                // 	for (let i = 0; i < objKeys.length; i++) {
                // 		let item = objKeys[i];
                // 		if (item.indexOf(upperFirstKey) != -1) {
                // 			console.log("getDict", this.dictInfoAllMap[item])
                // 			return this.dictInfoAllMap[item];
                // 		}
                // 	}
                // 	//forEach的函数的return是对他自己的回调函数的return，不是给最外面的方法的return
                // 	// objKeys.forEach((item,index)=>{
                // 	// 	if(item.indexOf(upperFirstKey)!=-1){
                // 	// 		console.log("getDict",this.dictInfoAllMap[item])
                // 	// 		return this.dictInfoAllMap[item];
                // 	// 	}
                // 	// })
                // },

                // getDictOps(key) {
                // 	let ops = [];
                // 	let upperFirstKey = this.upperFirst(key);
                // 	let objKeys = Object.keys(this.dictInfoAllMap);
                // 	for (let i = 0; i < objKeys.length; i++) {
                // 		let item = objKeys[i];
                // 		if (item.indexOf(upperFirstKey) != -1) {
                // 			console.log("getDict", this.dictInfoAllMap[item])
                // 			let opItem = {
                // 				value: item.split("-")[1],
                // 				name: this.dictInfoAllMap[item]
                // 			}
                // 			ops.push(opItem)
                // 		}
                // 	}
                // 	return ops;
                // },

            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/mixin/index.js